"use strict";

const API_URL = process.env.VUE_APP_ROOT_API
const axios = require("axios").default;


const ETahapTender = {
    NONE: 0,
    PENGUMUMAN: 1,
    DOWNLOAD_DOKUMEN_PEMILIHAN: 2,
    PEMBERIAN_PENJELASAN: 3,
    UPLOAD_DOKUMEN_PENAWARAN: 4,
    PEMBUKAAN_DOKUMEN_PENAWARAN: 5,
    UPLOAD_DOKUMEN_TEKNIS: 6,
    PEMBUKAAN_DOKUMEN_TEKNIS: 7,
    EVALUASI: 8,
    PEMBUKTIAN_KUALIFIKASI: 9,
    PENETAPAN_PEMENANG: 10,
    PENGUMUMAN_PEMENENANG: 11,
    MASA_SANGGAH_HASIL: 12,
    SURAT_PENUNJUKAN_PENYEDIA: 13,
    PENANDATANGANAN_KONTRAK: 14,
    SELESAI: 15
};


function isCurrentDateInRange(start, end) {
    const currentDate = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);
    console.log(`CurrentDate: ${currentDate}, StartDate: ${startDate}, EndDate: ${endDate}, Start:${start}, End:${end}, CurrentTime: ${startDate.getTime()}, StartTime:${currentDate.getTime()}, EndTime:${endDate.getTime()}`);
    return startDate <= currentDate && currentDate <= endDate;
}


const TenderLib = {
    
    resetTender: () => {
        return {
            id: "",
            nama: "",
            fileHPS: "",
            fileKAK: "",
            fileRancanganKontrak: "",
            fileInfoLain: "",
            fileDokumenPemilihan: "",
            filePersyaratanKualifikasi: "",
            filePersyaratanTeknis: "",
            filePersyaratanKeuangan: "",
            fileDokumenPenawaranTeknis: "",
            fileDokumenTender: "",
            kbli: "", 
            jenisPengadaan: '',
            metodePemilihan: '',
            metodeKualifikasi: '',
            metodeEvaluasi: '',
            jenisKontrak: '',
            pemenang: 1,
            tglPengumumanAwal: null,
            tglPengumumanAkhir: null,
            tglDownloadDokumenPemilihanAwal: null,
            tglDownloadDokumenPemilihanAkhir: null,
            tglPemberianPenjelasanAwal: null,
            tglPemberianPenjelasanAkhir: null,
            tglUploadDokumenPenawaranAwal: null,
            tglUploadDokumenPenawaranAkhir: null,
            tglPembukaanDokumenPenawaranAwal: null,
            tglPembukaanDokumenPenawaranAkhir: null,
            tglUploadDokumenTeknisAwal: null,
            tglUploadDokumenTeknisAkhir: null,
            tglPembukaanDokumenTeknisAwal: null,
            tglPembukaanDokumenTeknisAkhir: null,
            tglEvaluasiAwal: null,
            tglEvaluasiAkhir: null,
            tglPembuktianKualifikasiAwal: null,
            tglPembuktianKualifikasiAkhir: null,
            tglPenetapanPemenangAwal: null,
            tglPenetapanPemenangAkhir: null,
            tglPengumumanPemenangAwal: null,
            tglPengumumanPemenangAkhir: null,
            tglMasaSanggahAwal: null,
            tglMasaSanggahAkhir: null,
            tglSuratPenunjukanPenyediaAwal: null,
            tglSuratPenunjukanPenyediaAkhir: null,
            tglPenandatangananKontrakAwal: null,
            tglPenandatangananKontrakAkhir: null,
            status: "D0",
            listPaket: [],
            listPeserta: []
        }
    },

    getFileDownloadLink: (tenderId, type, fileName, bIsVendorFile) => {
        const path = bIsVendorFile ? `tender/${tenderId}/Vendor/${fileName}` : `tender/${tenderId}/${type}/${fileName}`;
        console.log(`Nama FIle: ${fileName}`)
        axios.get(`${API_URL}/${path}`, { responseType: 'blob' })
        .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
        })
        .catch( (error) => {
            console.error(error);
        });
    },


    getTahapTenderValue: (tender) => {
        if (tender == null) 
        {
            console.log("Invalid tender!");    
            return ETahapTender.NONE;
        }

        console.log("Tender: ", tender);

        // Check selesai
        if (tender.tglPenandatangananKontrakAkhir != null && Date.now() > Date.parse(tender.tglPenandatangananKontrakAkhir) ) return ETahapTender.SELESAI;

        if (isCurrentDateInRange(tender.tglPengumumanAwal, tender.tglPengumumanAkhir)) return ETahapTender.PENGUMUMAN;
        if (isCurrentDateInRange(tender.tglDownloadDokumenPemilihanAwal, tender.tglDownloadDokumenPemilihanAkhir)) return ETahapTender.DOWNLOAD_DOKUMEN_PEMILIHAN;
        if (isCurrentDateInRange(tender.tglDownloadDokumenPemilihanAkhir, tender.tglPemberianPenjelasanAkhir)) return ETahapTender.PEMBERIAN_PENJELASAN;
        if (isCurrentDateInRange(tender.tglUploadDokumenPenawaranAwal, tender.tglUploadDokumenPenawaranAkhir)) return ETahapTender.UPLOAD_DOKUMEN_PENAWARAN;
        if (isCurrentDateInRange(tender.tglPembukaanDokumenPenawaranAwal, tender.tglPembukaanDokumenPenawaranAkhir)) return ETahapTender.PEMBUKAAN_DOKUMEN_PENAWARAN;

        // Prakualifikasi
        if (tender.metodeKualifikasi === 'P')
        {
            if (isCurrentDateInRange(tender.tglUploadDokumenTeknisAwal, tender.tglUploadDokumenTeknisAkhir)) return ETahapTender.UPLOAD_DOKUMEN_TEKNIS;
            if (isCurrentDateInRange(tender.tglPembukaanDokumenTeknisAwal, tender.tglPembukaanDokumenTeknisAwal)) return ETahapTender.PEMBUKAAN_DOKUMEN_TEKNIS;
        }

        if (isCurrentDateInRange(tender.tglEvaluasiAwal, tender.tglEvaluasiAkhir)) return ETahapTender.EVALUASI;
        if (isCurrentDateInRange(tender.tglPembuktianKualifikasiAwal, tender.tglPembuktianKualifikasiAkhir)) return ETahapTender.EVALUASI;
        if (isCurrentDateInRange(tender.tglPenetapanPemenangAwal, tender.tglPenetapanPemenangAkhir)) return ETahapTender.PENETAPAN_PEMENANG;
        if (isCurrentDateInRange(tender.tglPengumumanPemenangAwal, tender.tglPengumumanPemenangAkhir)) return ETahapTender.PENGUMUMAN_PEMENENANG;
        if (isCurrentDateInRange(tender.tglMasaSanggahAwal, tender.tglMasaSanggahAkhir)) return ETahapTender.MASA_SANGGAH_HASIL;
        if (isCurrentDateInRange(tender.tglSuratPenunjukanPenyediaAwal, tender.tglSuratPenunjukanPenyediaAkhir)) return ETahapTender.SURAT_PENUNJUKAN_PENYEDIA;
        if (isCurrentDateInRange(tender.tglPenandatangananKontrakAwal, tender.tglPenandatangananKontrakAkhir)) return ETahapTender.PENANDATANGANAN_KONTRAK;

        return ETahapTender.NONE;
    },
    

    getTahapTenderAsString(tahapValue) {
        switch (tahapValue)
        {
            case ETahapTender.PENGUMUMAN: return "Pengumuman";
            case ETahapTender.DOWNLOAD_DOKUMEN_PEMILIHAN: return "Download Dokumen Pemilihan";
            case ETahapTender.PEMBERIAN_PENJELASAN: return "Pemberian Penjelasan";
            case ETahapTender.UPLOAD_DOKUMEN_PENAWARAN: return "Upload Dokumen Penawaran";
            case ETahapTender.PEMBUKAAN_DOKUMEN_PENAWARAN: return "Pembukaan Dokumen Penawaran";
            case ETahapTender.UPLOAD_DOKUMEN_TEKNIS: return "Upload Dokumen Teknis";
            case ETahapTender.PEMBUKAAN_DOKUMEN_TEKNIS: return "Pembukaan Dokumen Teknis";
            case ETahapTender.EVALUASI: return "Evaluasi";
            case ETahapTender.PEMBUKTIAN_KUALIFIKASI: return "Pembuktian Kualifikasi";
            case ETahapTender.PENETAPAN_PEMENANG: return "Penetapan Pemenang";
            case ETahapTender.PENGUMUMAN_PEMENENANG: return "Pengumuman Pemenang";
            case ETahapTender.MASA_SANGGAH_HASIL: return "Masa Sanggah Hasil";
            case ETahapTender.SURAT_PENUNJUKAN_PENYEDIA: return "Surat Penunjukan Penyedia";
            case ETahapTender.PENANDATANGANAN_KONTRAK: return "Penandatanganan Kontrak";
            case ETahapTender.SELESAI: return "Selesai";
            default: return "NONE";
        }
    },

};


function validateJadwalLelang(listJadwal = []) {
    if (listJadwal.length === 0) return "Jadwal kosong!";

    const filteredListJadwal = listJadwal.filter(jadwal => jadwal.include === true);
    const count = filteredListJadwal.length;

    // Validate semua jadwal terisi
    for (let i = 0; i < count; ++i) {
        const jadwal = filteredListJadwal[i];
        if (!jadwal.include) continue;

        if (jadwal.mulai == null || jadwal.mulai === "" || jadwal.selesai == null || jadwal.selesai === "") {
            return `[${jadwal.tahap}] Tanggal mulai dan selesai harus diisi`;
        }
    }   

    // Validate tgl mulai dan selesai
    for (let i = 0; i < count; ++i) {
        const currentJadwal = filteredListJadwal[i];
        const currentJadwalStartDateTime = Date.parse(currentJadwal.mulai);
        const currentJadwalEndDateTime = Date.parse(currentJadwal.selesai);

        if (currentJadwalStartDateTime >= currentJadwalEndDateTime) {
            return `[${currentJadwal.tahap}] Tanggal mulai tidak boleh melebihi atau bersamaan dengan tanggal selesai`;
        }

        const nextListJadwal = filteredListJadwal.slice(i + 1, count);
        
        for (let j = 0; j < nextListJadwal.length; ++j) {
            const nextJadwal = nextListJadwal[j];

            if (currentJadwalEndDateTime >= Date.parse(nextJadwal.mulai)) {
                return `Tanggal mulai pada jadwal [${nextJadwal.tahap}] tidak boleh mendahului atau bersamaan dengan tanggal selesai pada jadwal [${currentJadwal.tahap}]`
            }
        }
    }

    // Valid (No error validation message)
    return "";
}


function validateRevisiJadwalLelang(listJadwal = [], revisiJadwal = []) {

    const revisiValidationMessage = validateJadwalLelang(revisiJadwal);

    if (revisiValidationMessage !== "") {
        return revisiValidationMessage;
    }

    const count = listJadwal.length;

    for (let i = 0; i < count; ++i) {
        const jadwal = listJadwal[i];
        const revisi = revisiJadwal[i];
        const jadwalStartDateTime = Date.parse(jadwal.mulai);
        const jadwalEndDateTime = Date.parse(jadwal.selesai);
        const revisiStartDateTime = Date.parse(revisi.mulai);
        const revisiEndDateTime = Date.parse(revisi.selesai);
        const changed = (jadwal.include !== revisi.include) || (jadwalStartDateTime !== revisiStartDateTime) || (jadwalEndDateTime !== revisiEndDateTime);

        if (changed && (revisi.remark == null || revisi.remark === "")) {
            console.log("Tahap:", jadwal.tahap, revisi.tahap);
            console.log("Start:", jadwalStartDateTime, revisiStartDateTime);
            console.log("End:", jadwalEndDateTime, revisiEndDateTime);
            console.log("Include:", jadwal.include, revisi.include);
            return `Ada perubahan pada jadwal [${jadwal.tahap}]. Harap mengisi remark!`;
        }
    }

    return "";
}


module.exports =  { ETahapTender, TenderLib, validateJadwalLelang, validateRevisiJadwalLelang }
